import * as DetailPanel from '../../../components/detail-panel'
import * as Form from '../../../components/form'

export const MEMBER_DETAIL_PREFIX = 'MEMBER_DETAIL'

export const DetailPanelConstants = DetailPanel.createConstantsMap(MEMBER_DETAIL_PREFIX)
export const FormConstants = Form.createConstantsMap(MEMBER_DETAIL_PREFIX)
export const EditFieldActions = Form.createActionsMap(MEMBER_DETAIL_PREFIX)



// WEBPACK FOOTER //
// ./src/pages/members/details/constants.ts